export default __webpack_public_path__ + "static/media/crown1.cebc4b76.png";